import angular from 'angular';
import { TitleizeFilter as filter } from './titleize.filter';

export const TitleizeFilter = angular
  .module('angular-common.filters.titleize', [])
  .filter('titleizeFilter', filter);
